<script lang="ts">
  import { Timer } from '@shared/ui/timer';

  import CardInfo from './auction-card-info.svelte';

  export let endDate: Date;
  export let isUserBestBidder: boolean;
  export let bestBid: string | undefined;
  export let price: string;
</script>

<ul class="flex items-center gap-8">
  <CardInfo {isUserBestBidder} {bestBid} {price} />

  <li>
    <p class="text-default-500 dark:text-dark-800 mb-1.5 text-base">Auction ends</p>

    <Timer
      {endDate}
      classes="text-[16px] lg:text-[16px] w-fit py-1 md:text-[16px] border-default-500 rounded-lg px-2.5 border leading-[20px]"
    />
  </li>
</ul>
